import React from 'react';

import { Body1, Heading4, Tag } from '../Typography';

import styles from './index.module.scss';

export interface CenteredImageWithTextProps {
  imageUrl?: string;
  imageAlt?: string;
  label?: string;
  title: string;
  text?: string;
}

const CenteredImageWithText: React.FC<CenteredImageWithTextProps> = ({
  imageUrl, // 205x205px
  imageAlt,
  label,
  title,
  text,
}) => {
  return (
    <div className={styles.wrapper}>
      {imageUrl && (
        <div className={styles.imageWrapper}>
          <img src={imageUrl} alt={imageAlt} className={styles.image} />
        </div>
      )}
      <div className={styles.textWrapper}>
        {label && <Tag className={styles.label}>{label}</Tag>}
        <Heading4 className={styles.title}>{title}</Heading4>
        {text && <Body1 className={styles.text}>{text}</Body1>}
      </div>
    </div>
  );
};

export default CenteredImageWithText;
